import { useSelector } from "react-redux"
import { useState } from "react"
import { IFWStatementsData } from "../../../constant/staticData"
import { useEffect } from "react"

const IFWStatements = () => {
    const { application } = useSelector((state) => state.application)
    const [selectedStatement, setSelectedStatement] = useState(null)

    useEffect(() => {
        const state = IFWStatementsData.find((s) => s.value === application?.firstNamedInsuredState)
        setSelectedStatement(state)
    }, [application?.firstNamedInsuredState])

    return (
        <div>
            {application?.firstNamedInsuredState && selectedStatement ? (
                <div style={{ display: "flex" }}>
                    <div style={{ flex: 1 }}>
                        <h6>{selectedStatement?.state}</h6>
                        {Array.isArray(selectedStatement?.statement) ? (
                            selectedStatement?.statement?.map((s, i) => (
                                <div
                                    className="mb-4"
                                    key={i}>
                                    {s}
                                </div>
                            ))
                        ) : (
                            <div>{selectedStatement?.statement}</div>
                        )}
                    </div>
                    <div style={{ flex: 8 }}>
                        {Array.isArray(selectedStatement?.heading) ? (
                            selectedStatement?.heading?.map((h, i) => (
                                <div key={i}>
                                    <h6>{selectedStatement?.heading[i]}</h6>
                                    <div className="mb-4">{selectedStatement?.description[i]}</div>
                                </div>
                            ))
                        ) : (
                            <>
                                <h6>{selectedStatement?.heading}</h6>
                                <div>{selectedStatement?.description}</div>
                            </>
                        )}
                    </div>
                </div>
            ) : application?.firstNamedInsuredState && !selectedStatement ? (
                <div className="pb-4">Insurance Fraud Warning Statement not found against the selected state.</div>
            ) : (
                <div className="pb-4">Please select your state to view its Insurance Fraud Warning Statement.</div>
            )}
        </div>
    )
}

export default IFWStatements
